
/**
 * @file Created on Thu Nov 15 2018
 * @module ui
 * @author wangyongqing <wangyongqing01@baidu.com>
 */

import register from '../register';
import {getParams} from '../utils';
import {open} from './index';

register('utils/openShareBox', {
    androidlite: {
        versionRange: ['2.2.2']
    },
    androidinfo: {
        versionRange: ['1.0']
    },
    iosinfo: {
        versionRange: ['1.1']
    },
    androidmission: {
        versionRange: ['1.0']
    },
    iosmission: {
        versionRange: ['1.0']
    },
    ios: {
        hasCB: false,
        versionRange: ['5.3.5'],
        filter(module, action, data) {
            return {
                module: 'callShare',
                action: '',
                paramName: 'options',
                extData: {
                    minver: '5.3.5.0'
                }
            };
        }
    },
    android: {
        versionRange: ['5.3.5'],
        hasCB: false,
        filter(module, action, data) {
            let d = {
                imageUrl: data.iconUrl,
                title: data.title,
                content: data.content,
                linkUrl: data.linkUrl,
                mediaType: data.mediaType,
                channel: data.pannel,
                shareSuccessCB: data.shareSuccessCB || 'console.log',
                shareErrorCB: data.shareErrorCB || 'console.log'
            };
            if (data.type === 'audio') {
                d.type = '2';
            } else if (data.type === 'image') {
                d.type = '3';
            } else if (data.type === 'video') {
                d.type = '4';
            } else {
                d.type = '1';
            }
            return {
                module: 'Bdbox_android_utils',
                action: 'callShare',
                data: d
            };
        }
    }
});

/**
 * 分享面板
 * @function openShare
 * @param {Object} params 端能力参数
 * @return {Promise} 调用的返回
 */
export default (params = {}) => {
    return open(
        getParams('utils-shareBox', params, {
            data: {
                mediaType: 'all',
                type: 'url',
                shareSuccessCB: 'console.log',
                shareErrorCB: 'console.log'
            }
        })
    );
};
